import { AUTH_URL } from 'utils/constants';
import client from './client';

const Auth = {
  signIn(data) {
    return client.post('/sign_in', data);
  },

  sendCode(data) {
    client.setBaseURL(AUTH_URL);

    return client.post('/send_code', data);
  },

  resendCode(data) {
    return client.post('/send_code', data);
  },
};

export default Auth;
